import { Card, EditIcon } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { SubstitutionPlanForm } from '../../../../components/Substitutions/forms/SubstitutionPlanForm';
import { SubstitutionPlanModal } from '../../../../components/Substitutions/modals/SubstitutionPlanModal';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const SubstitutionPlanSettingsPage = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <Page isForbidden={!permissions?.canManageSubstitution()} title={t('substitutions.substitutionPlan')}>
      <Card
        showHeaderMargin
        header={{
          headline: t('common.overview'),
          actions: [
            {
              callback: () => setModalOpen(true),
              icon: <EditIcon />,
              text: t('substitutions.settings.editSubstitutionPlan'),
              hierarchy: 'primary',
            },
          ],
        }}
      >
        <SubstitutionPlanForm readonly />
      </Card>

      <SubstitutionPlanModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </Page>
  );
};
